<template>
    <div class="builds-container">
        <h4 v-if=" this.getBuildsLoaded" style="border-bottom: 1px solid #434857; padding-bottom: 15px; text-align: left; padding-left: 5px">Recent builds</h4>
        <div v-if="getBuildsLoaded" class="builds-list">
            <div v-for="(build, index) in getRecentBuilds" :key="index" class="build-item">
                <!-- top -->
                <div>
                    <!-- Image -->
                    <div style="display:inline-block; " v-if="build['case']" class="shadow build-thumbnail" 
                        :style="[
                            build.case.mainImg 
                            ? {backgroundImage: 'url(' + build.case.mainImg +')'} 
                            : JSON.parse(build.case.imgUrl)[0].includes('<a href') 
                            ? {backgroundImage: 'url(' + JSON.parse(build.case.imgUrl)[1] + ')'}
                            : {backgroundImage: 'url(' + JSON.parse(build.case.imgUrl)[0] + ')'}
                            ]">
                            </div>
                    <!-- Title -->
                    <div style="width: 61%;" class="title-by">
                        <h4 style="font-size: 25px !important; padding-left: 5px; margin-top: 1px; margin-bottom:3px; color: #cfd2da !important">{{build.name}}</h4> 
                        <!-- <p style="color: #9198aa;">
                            <a style="">by {{build.author_name || ''}}</a> 
                        </p> -->
                        
                    </div>
                    <!-- Price and Buttons -->
                    <div class="build-info" >
                        <div class="build-buttons">
                            <div class="build-price-tag" style="margin-top: -3px;display:block;">
                                <div style="font-size: 22px; " class="price-tag">
                                    <div style="display: inline-block;color: rgb(145, 152, 170);opacity: 1;margin-right: -3px;font-size: 14px;margin-top: 1px; vertical-align: top;">
                                        $ 
                                    </div>
                                {{calculateBuild(build).totalCost.toFixed(0)}}
                                <div style="display: inline-block; font-size: 15px; vertical-align: top; margin-top: 3px; margin-left: -6px;">
                                    <span style="color: #9198aa">.</span>{{(((calculateBuild(build).totalCost.toFixed(2)%1).toFixed(2))*100).toFixed(0)}}
                                </div>
                                </div>
                            </div>
                            <div class="list-icon check-btn add-to-build-btn ">
                                <span @click="loadBuild(build), scrollToTop()" style="display: flex; justify-content: center;" class="clone-button gc-button smaller-btn ">
                                <!-- <span class="icon icon-arrow-up"></span> -->
                                Clone</span>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <!-- Bars -->
                <div class="build-specs">
                    <div class="build-spec" v-for="(item, index) in Object.keys(build).filter(item => welcomedItems.includes(item)).reverse()" :key="index">
                        <!-- Graphics Score -->
                        <div style="width: 100%;" v-if="item == 'graphics'">
                            <!-- <div>{{build[item][0].model}}</div> -->

                            <!-- BAR -->
                            <div class="skills">
                                <div class="details">
                                    <span style="padding-left: 6px;">{{build[item][0].model}}</span>
                                </div>
                                <div class="bar1">
                                    <div style="max-width: 100%;" 
                                        :style="[
                                        {width:  getPerfWidth(getPerformance(build, false).Details[item], parseFloat(5000)) + '% !important'}, 
                                        getPerfWidth(getPerformance(build, false).Details[item], parseFloat(5000)) < 20 ? {'background-color': '#e64759 ', border: '1px solid #e64759', 'box-shadow': 'none'} 
                                        : getPerfWidth(getPerformance(build, false).Details[item], parseFloat(5000)) < 40 ? {'background-color': '#e4d836 ', border: '1px solid #e4d836', 'box-shadow': 'none'} 
                                        : '']" 
                                        id="html-bar">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Processor Score -->
                        <div style="width: 100%;"  v-if="item == 'processor'">
                            <!-- BAR -->
                            <div class="skills">
                                <div class="details">
                                    <span style="padding-left: 6px;">{{build[item].model}}</span>
                                </div>
                                <div class="bar1">
                                    <div style="max-width: 100%;" 
                                        :style="[
                                        {width:  getPerfWidth(getPerformance(build, false).Details[item], parseFloat(5000)) + '% !important'}, 
                                        getPerfWidth(getPerformance(build, false).Details[item], parseFloat(5000)) < 20 ? {'background-color': '#e64759 ', border: '1px solid #e64759', 'box-shadow': 'none'} 
                                        : getPerfWidth(getPerformance(build, false).Details[item], parseFloat(5000)) < 40 ? {'background-color': '#e4d836 ', border: '1px solid #e4d836', 'box-shadow': 'none'} 
                                        : '']" 
                                        id="html-bar">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- RAM Score -->
                        <div style="width: 100%;"  v-if="item == 'ram'">
                            <!-- BAR -->
                            <div class="skills">
                                <div class="details">
                                    <span style="padding-left: 6px;">{{getItemValue({item: build[item], field:'capacity'})}} <span>GB RAM</span></span>
                                </div>
                                <div class="bar1">
                                    <div style="max-width: 100%;" 
                                        :style="[
                                        {width:  getPerfWidth(getPerformance(build, false).Details[item], parseFloat(5000)) + '% !important'}, 
                                        getPerfWidth(getPerformance(build, false).Details[item], parseFloat(5000)) < 20 ? {'background-color': '#e64759 ', border: '1px solid #e64759', 'box-shadow': 'none'} 
                                        : getPerfWidth(getPerformance(build, false).Details[item], parseFloat(5000)) < 40 ? {'background-color': '#e4d836 ', border: '1px solid #e4d836', 'box-shadow': 'none'} 
                                        : '']" 
                                        id="html-bar">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Storage Score -->
                        <div style="width: 100%;"  v-if="item == 'storage'">
                            <!-- BAR -->
                            <div class="skills">
                                <div style="padding-left: 6px;" class="details">
                                    {{getItemValue({item: build[item], field:'capacity'})}} <span>TB STORAGE</span>
                                </div>
                                <div class="bar1">
                                    <div style="max-width: 100%;" 
                                        :style="[
                                        {width:  getPerfWidth(getPerformance(build, false).Details[item], parseFloat(5000)) + '% !important'}, 
                                        getPerfWidth(getPerformance(build, false).Details[item], parseFloat(5000)) < 20 ? {'background-color': '#e64759 ', border: '1px solid #e64759', 'box-shadow': 'none'} 
                                        : getPerfWidth(getPerformance(build, false).Details[item], parseFloat(5000)) < 40 ? {'background-color': '#e4d836 ', border: '1px solid #e4d836', 'box-shadow': 'none'} 
                                        : '']" 
                                        id="html-bar">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
                
                                <!-- Benchmark -->
                <!-- <div style="display: none;" class="build-perf">
                    <div style="vertical-align: bottom; border-radius: 6px 7px 7px 6px; margin-top: 5px; margin-left: 0px;" class="benckmark progress flex-row-reverse">
                        <div
                            class="progress-bar bg-succsess"
                            role="progressbar"
                            :style="{ width: 100 - getPerformance(build, false).Total/2 + '%'}"
                            aria-valiemin="0"
                            style="background-color: #2A2D35; border-radius: 0px 6px 6px 0px;"
                            aria-valuemax="100"
                        >
                        </div>
                        <div class="performance-bar bar-shadow" :style="{ width: 100 - getPerformance(build, false).Total/2 + '%'}" style="text-align: left; padding-left: 5px; color: #191b20; font-weight: bold; font-size: 13px; float: left;"></div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import { EventBus } from '../eventBus'
import {functions} from '../functions'
export default {
    name: 'RecentBuilds',
    data(){
        return {
            bars:[
                {
                    height:         '4px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#e4d836'
                },
                {
                    height:         '8px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#e4d836'
                },
                {
                    height:         '12px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#e4d836'
                },
                {
                    height:         '16px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#AFC543'
                },
                {
                    height:         '20px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#AFC543'
                },
                {
                    height:         '24px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#AFC543'
                },
                {
                    height:         '28px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#92C14F'
                },
                {
                    height:         '32px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#92C14F'
                },
                {
                    height:         '36px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#92C14F'
                },
                {
                    height:         '40px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#00BC8C'
                },
                {
                    height:         '44px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#00BC8C'
                },
                {
                    height:         '48px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#00BC8C'
                },
                {
                    height:         '52px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#00BC8C'
                },
                {
                    height:         '56px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#00BC8C'
                },
                {
                    height:         '60px',
                    width:          '8px',
                    color:          '#434857',
                    activeColor:    '#00BC8C'
                },
            ],
            welcomedItems: [
                'processor',
                'ram',
                'storage',
                'graphics'
                
            ]
        }
    },
    computed: {
        ...mapGetters([
            'getRecentBuilds',
            'getBuildsLoaded',
            'getMaxScores'
        ])
    },
    methods:{
        ...mapActions([
            'fetchRecentBuilds',
            'loadMoreBuilds',
            'loadBuild'
        ]),
        getHeight(height){
            var h = parseInt(height)
            var p = h*(h*0.018)
            return p+'px'
        },
        getItemValue:       ({item, field})     =>  functions.getItemValue({item, field}),
        getPerformance: (build, myBuild) => functions.getBuildPerformance(build, myBuild),
        calculateBuild (build) {
            const localBuild = build
            var totalCost = 0
            var tdp = 0
            for (const item in localBuild){
                if (localBuild[item]){
                    if(typeof(localBuild[item]) == 'object'){
                        if(localBuild[item].compat && localBuild[item].amzn_price){
                            totalCost += parseFloat(localBuild[item].amzn_price)
                            tdp += parseInt(localBuild[item].compat.tdp)
                        }
                        else if(localBuild[item].length >0){
                            for(var j = 0; j< localBuild[item].length; j++){
                                if(localBuild[item][j].type == 'ram'||localBuild[item][j].type == 'storage'||localBuild[item][j].type == 'gpu'|| localBuild[item][j].type == 'graphics')
                                totalCost += parseFloat(localBuild[item][j].amzn_price)
                                // console.log(localBuild[item][j].amzn_price + ' added to total cost: ', totalCost)
                                if(localBuild[item][j].type == 'ram'){
                                    tdp += 3*(parseInt(localBuild[item][j].compat.capacity) / 8)
                                }
                                else{
                                    tdp += parseInt(localBuild[item][j].compat.tdp)
                                }
                            }
                        }
                    }
                    else if(typeof(localBuild[item]) !== 'number' && typeof(localBuild[item]) !== 'string') {
                        totalCost += parseFloat(localBuild[item].amzn_price)
                        if(localBuild[item].type !== 'psu' && localBuild[item].type !== 'case'){
                            tdp += parseInt(localBuild[item].compat.tdp)
                        }
                    }
                }      
            }
            return {
                tdp: tdp,
                totalCost: totalCost
            }
        },
        getPerfWidth(perf, max){
            if(perf && max){
                var itemPerf = perf
                var maxPerf = max
                var score = (itemPerf*100)/maxPerf
                return parseFloat(score).toFixed(2)
            }
            return 0
        },
        scrollToTop() {
            window.scrollTo(0,0);
            EventBus.$emit('typeChange', 'cpu')
        },
        getPerfColor(score, barIndex){
            var totalBars = this.bars.length
            var maxPerf = 160
            var bar = maxPerf/totalBars
            var result = score/(bar)
            if(result >= barIndex){
                return '#1997c6'
            }
            if(result < barIndex){
                return 'transparent'
            }
        },
    },
    mounted(){
        this.fetchRecentBuilds({limit: 4})
    }
}
</script>
<style scoped>
.build-perf {
    position: absolute;
    bottom: 4px;
    width: 100%;
    padding-right: 20px;
}
.build-info {
    float: right;
    position: absolute;
    display: inline-block;  
    padding: 0px 0px; 
    padding-left: 0px;
    letter-spacing: 1px;  
    color: #1997c6;
    /* position: relative; */
    padding-left: 10px;
    padding-right:5px;
    text-align: center;
    right: 10px;
}
.bar {
    border-radius: 3px;
    height: 20px;
    border: 1px solid #434857;
    display:inline-block;
    width: 10px;
    margin-left: 10px;
}
.builds-container {
    text-align: center;
    margin-right: 10px;
}
@media screen and (max-width: 1200px){

}
.build-buttons {
    right: 2px;
    bottom: 0px;

}
.build-thumbnail {
    border-radius: 6px;
    width: 22%;
    height: 11.5vw;
    min-height: 72px;
    max-height: 240px;
    background-size: contain;
    background-repeat: no-repeat;
    background-color:white;
    background-position: center;
}
.builds-list {
    padding: 10px 0px;
    display: block;
}
.title-by {
    overflow: hidden;
    display: inline-block;
    vertical-align: top;
    padding-left: 10px;
}
#bar1 {

}
.build-perf-bars {
    display:inline-block;
    width: 45%;
    margin-right: 52px;
    float: right;
    margin-top: -41px;
    
}
.benckmark {
    margin-top: 40px;
}
.bar-shadow {
    width: 100% !important;
    float: left !important;
}

.build-price-tag {
    display: inline-block;
}
.small-button {
    height: 28px;
    font-size: 16px !important;
    padding: 2px;
}
.build-item {
    min-width: 280px;
    width: 48%;
    text-align: left;
    display:inline-block;
    border: 1px solid #434857;
    border-radius: 6px;
    margin: 0.6%;
    padding: 10px;
    vertical-align: top;
    position: relative;
}
.build-specs {
    display: grid;
    vertical-align: top;
    position: relative;
    width: 100%
}
.build-spec {
    display: flex;
    /* border: 1px solid #434857; */
    border-radius: 6px;
    padding: 5px;
    margin-right: 2%;
    text-align: left;
    font-size: 16px;
    padding-left: 0px;
    padding-bottom: 0px;
}
.build-spec-perf {
    background: #1997c6;
    width: 100%;
    height: 4px;
}
.skills:not(:last-child){
    margin-bottom: 30px;
}
.details{
    width: 100%;
    display: flex;
}
.bar1{
    position: relative;
    background-color: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.06);
    padding: 3px 5px;
    border-radius: 20px;
    backdrop-filter: blur(10px);
}
.bar1 div{
    position: relative;
    width: 0;
    height: 4px;
    border-radius: 10px;
    background-color: #00bc8c;
    border: 1px solid #03AC81;
    box-shadow: 0 0 5px rgba(35, 158, 87, 0.6);
}
#html-bar{
    animation: html-fill 2s forwards;
}
@media (max-width: 1266px) {
    .build-item {
        margin-left: 0px;
    }
}
@keyframes html-fill{
    100%{
        width: 90%;
    }
}
#css-bar{
    animation: css-fill 2s forwards;
}
@keyframes css-fill{
    100%{
        width: 75%;
    }
}
#js-bar{
    animation: js-fill 2s forwards;
}
@keyframes js-fill {
    100%{
        width: 82%;
    }
}
#jQuery-bar{
    animation: jQuery-fill 2s forwards;
}
@keyframes jQuery-fill{
    100%{
        width: 68%;
    }
}
</style>